import React from 'react';
import Icon from '../openplay/OpenPlayIcon';
import VenueSearchResultItem from './VenueSearchResultItem';

const VenueSearchModal = ({
  isOpen,
  query,
  onChangeQuery,
  onSubmit,
  isLoading,
  error,
  results,
  onSelectResult,
  onClose,
}) => {
  if (!isOpen) return null;

  const safeResults = Array.isArray(results) ? results : [];

  return (
    <div
      className="fixed inset-0 z-[10001] flex items-start justify-center pt-[10vh] px-4"
      onClick={(e) => {
        if (e?.target === e?.currentTarget) onClose?.();
      }}
    >
      <div className="fixed inset-0 bg-background/70 backdrop-blur-sm z-10" aria-hidden="true" />
      <div className="relative z-20 w-full max-w-2xl bg-card border border-border rounded-xl shadow-2xl overflow-hidden">
        <div className="bg-card border-b border-border p-4 flex items-center justify-between">
          <div>
            <h2 className="text-lg font-heading font-semibold text-foreground">장소 검색</h2>
            <p className="text-xs caption text-muted-foreground mt-0.5">주소를 검색하고 선택하세요</p>
          </div>
          <button
            type="button"
            className="p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-athletic"
            onClick={onClose}
            aria-label="닫기"
          >
            <Icon name="XMarkIcon" size={20} />
          </button>
        </div>

        <div className="p-4 space-y-3">
          <div className="flex gap-2">
            <input
              className="flex-1 px-4 py-3 bg-muted/30 border border-border rounded-md text-foreground"
              value={query}
              onChange={(e) => onChangeQuery?.(e?.target?.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  onSubmit?.();
                }
              }}
              placeholder="예: 서울 서대문구 이화여대길 52, 성남시 분당구 불정로 6"
            />
            <button
              type="button"
              onClick={onSubmit}
              disabled={isLoading}
              className="h-11 px-4 rounded-lg bg-primary text-primary-foreground font-semibold disabled:opacity-60"
            >
              검색
            </button>
          </div>

          {error && (
            <div className="bg-error/10 border border-error/20 rounded-md p-3 flex items-start gap-2">
              <Icon name="ExclamationTriangleIcon" size={18} className="mt-0.5 text-error" />
              <p className="text-sm text-error">{error}</p>
            </div>
          )}

          <div className="max-h-[60vh] overflow-y-auto divide-y divide-border border border-border rounded-lg">
            {safeResults.map((row, idx) => {
              const address = String(row?.roadAddress || row?.jibunAddress || '').trim();
              return (
                <VenueSearchResultItem
                  key={`${address}-${idx}`}
                  row={row}
                  onSelect={onSelectResult}
                />
              );
            })}

            {safeResults.length === 0 && !isLoading && !error && (
              <div className="p-4">
                <p className="text-sm text-muted-foreground">주소 형태로 검색해보세요. (예: "서울 서대문구 이화여대길 52")</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VenueSearchModal;
